export default __webpack_public_path__ + "static/media/usd.99ba536d.png";